import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule],
  template: `
  <button
      [class]="getButtonClasses()"
      (click)="onButtonClick()"
      [type]="buttonType"
      [disabled]="isDisabled">
      <ng-content></ng-content>
    </button>
  `
})
export class ButtonComponent {
  @Output() buttonClick = new EventEmitter<any>();

  @Input() buttonStyle: 'default' | 'primary' | 'edit' | 'delete' | 'close' = 'default';
  @Input() buttonType: string = 'button';
  @Input() isDisabled: boolean = false;
  @Input() hasIcon: boolean = false;

  onButtonClick(): void {
    this.buttonClick.emit();
  }

  getButtonClasses(): string {
    let baseClasses = 'py-2 px-3 text-sm font-normal text-center rounded-lg transition-all disabled:bg-gray-600';
    let typeClasses = '';

    switch (this.buttonStyle) {
      case 'default':
        typeClasses = 'text-white rounded-lg bg-black hover:bg-gray-700 text-sm px-5 py-2.5';
        break;
      case 'primary':
        typeClasses = 'text-white rounded-lg bg-blue-600 hover:bg-blue-700 text-sm px-5 py-2.5';
        break;
      case 'edit':
        typeClasses = 'inline-flex items-center text-gray-700 bg-gray-200 hover:bg-gray-300 hover:text-gray-900';
        break;
      case 'delete':
        typeClasses = 'text-white bg-red-500 hover:bg-red-600';
        break;
      case 'close':
        typeClasses = 'text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-2xl text-sm p-1.5 ml-auto';
        break;
    }

    if (this.hasIcon) {
      baseClasses += ' inline-flex items-center';
    }

    return `${baseClasses} ${typeClasses}`;
  }
}
